import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { selectPageMeta } from '../../selectors/seo';

export const PageMetaContainer: React.FC<{}> = () => {
  const { title, metaDescription } = useSelector(selectPageMeta);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};
